// Shared visibility predicate for the schedule creator timeline.
//
// Both artist assignments and custom-subject rows must react to the same two
// controls so the producer gets a consistent overview:
//   - the per-crew-member eye toggle (`hiddenCrew`), and
//   - the "Show assigned" crew dropdown (`selectedCrewFilter`).
//
// Previously the eye toggle only hid custom subjects (because those rows were
// derived from an already-filtered crew list) while artist assignments stayed
// visible. Centralising the rule here keeps the two render paths in sync.

export interface CrewVisibilityFilter {
  /** Crew member ids the producer has hidden via the eye icon. */
  hiddenCrew: Set<string>;
  /** "all" or a single crew_member_id selected in the "Show assigned" dropdown. */
  selectedCrewFilter: string;
}

/**
 * Whether content belonging to `crewMemberId` should be visible on the
 * timeline given the hidden-crew set and the "Show assigned" filter.
 *
 * A hidden crew member is never shown, regardless of the dropdown. When the
 * dropdown targets a specific member, only that member is shown.
 */
export function isCrewMemberVisible(
  crewMemberId: string,
  { hiddenCrew, selectedCrewFilter }: CrewVisibilityFilter,
): boolean {
  if (hiddenCrew.has(crewMemberId)) return false;
  if (selectedCrewFilter === "all") return true;
  return crewMemberId === selectedCrewFilter;
}
